<script setup>
import { useA11yStore } from '../../../stores/a11y'

const a11y = useA11yStore()
</script>

<template>
  <div
    aria-live="polite"
    role="status"
    class="absolute w-[1px] h-[1px] -m-px p-0 overflow-hidden whitespace-nowrap border-0"
    style="clip: rect(0 0 0 0); clip-path: inset(50%)"
  >
    {{ a11y.message }}
  </div>
</template>
